import {
    ClickMix,
    Comandas,
    Ifood,
    LojaIntegrada,
    Mobile,
    NuvemShop,
    OSuper,
    PidoMe,
    S2Pay,
    SiteMercado,
    SupermercadosNow
} from '../../components/sistemas-integracao/sistemas-integracao'
import Ellipse1 from '../../components/public/pdv/ellipse11455-k5ug.svg'
import Ellipse2 from '../../components/public/pdv/ellipse11454-26rd.svg'
import Back1 from '../../components/public/background/Background PDV/1.png'
import Back2 from '../../components/public/background/Background PDV/2.png'
import Back3 from '../../components/public/background/Background PDV/3.png'
import BackFiguras1 from '../../components/public/background/Background PDV/Figuras/1.png'
import BackFiguras2 from '../../components/public/background/Background PDV/Figuras/2.png'
import BackFiguras3 from '../../components/public/background/Background PDV/Figuras/3.png'
import BackFiguras4 from '../../components/public/background/Background PDV/Figuras/4.png'
import BackFiguras5 from '../../components/public/background/Background PDV/Figuras/5.png'
import BackFiguras6 from '../../components/public/background/Background PDV/Figuras/6.png'
import BackFiguras7 from '../../components/public/background/Background PDV/Figuras/7.png'
import BackDesk1 from '../../components/public/background/Background PDV/Desktop/back1.png'
import BackDesk2 from '../../components/public/background/Background PDV/Desktop/back2.png'
import BackDesk3 from '../../components/public/background/Background PDV/Desktop/back3.png'
import BackDesk4 from '../../components/public/background/Background PDV/Desktop/back4.png'
import BackDesk5 from '../../components/public/background/Background PDV/Desktop/back5.png'
import BackFigurasDesk1 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu1.png'
import BackFigurasDesk2 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu2.png'
import BackFigurasDesk3 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu3.png'
import BackFigurasDesk4 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu4.png'
import BackFigurasDesk5 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu5.png'
import BackFigurasDesk6 from '../../components/public/background/Background PDV/Desktop/Figuras/backFigu6.png'
import PDVCaixa from '../../components/public/pdv/PDV CAIXA.png'
import Group15158 from '../../components/public/pdv/group15158-irqi.svg'
import Group480879 from '../../components/public/pdv/group480879-ci.svg'
import Group4721050 from '../../components/public/pdv/group4721050-5xzp.svg'
import Group4721012 from '../../components/public/pdv/group4721012-k26.svg'
import Group4721051 from '../../components/public/pdv/cupom-sat-nfe.svg'
import Group1221 from '../../components/public/pdv/Group 1221.png'
import image1414536 from '../../components/public/pdv/image1414536-q97-200w.png'
import Image1 from '../../components/public/imagens sistema/PDV/Image1.png'
import Image2 from '../../components/public/imagens sistema/PDV/Image2.png'
import Image3 from '../../components/public/imagens sistema/PDV/Image3.png'
import Image4 from '../../components/public/imagens sistema/PDV/Image4.png'
import Image5 from '../../components/public/imagens sistema/PDV/Image5.png'
import WhiteLabel from '../../components/public/pdv/white-label.png'
import SuporteTecnico from '../../components/public/pdv/suporte-tecnico.png'
import './autoComPDV.css'
import './background.css'
import { IconsGrande, IconsPequeno } from '../../components/icons-sistema/icons-sistema'
import { useKeenSlider } from 'keen-slider/react'
import { Link } from 'react-router-dom'
import { QrCode } from '../../components/qrcode/qrcode'
import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider'
import { useHistory } from 'react-router'
import { Footer } from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
import MenuIcon from '@material-ui/icons/Menu';
import { Box, Button, Divider, IconButton, List, ListItemIcon, SwipeableDrawer, Toolbar, Typography, useTheme } from '@material-ui/core'
import { useState } from 'react'
import clsx from 'clsx';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import { useStyles } from './pdv-style'
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage'

export const SaurusPDV = () => {
    const { DefinirRota, IsValidSession, Logout } = useSessaoAtual()
    const classes = useStyles()
    const theme = useTheme();
    DefinirRota('/saurus-pdv')
    const history = useHistory()
    const [open, setOpen] = useState(false);
    const { getRegister } = useBaixasStorage();
    const user = getRegister(BaixasStorageKeys.data)

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpen(false);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    if (!IsValidSession) history.push('/')
    const [refCallback] = useKeenSlider(
        {
            slides: { perView: 'auto', spacing: 10 },
        },
        [
            // add plugins here
        ]
    )

    return (
        <>
            {user.id ?
                <>
                    <Toolbar className={classes.appBar}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, open && classes.hide)}
                        >
                            <MenuIcon className={classes.menuButton} />
                            <Typography style={{ fontSize: '17px', padding: '0 15px' }} variant="h4">
                                Saurus PDV
                            </Typography>
                        </IconButton>
                        {/* <QrCode backColor="#386D9F" /> */}
                    </Toolbar>
                    <SwipeableDrawer
                        className={classes.drawer}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        open={open}
                        anchor={'left'}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <div className={classes.drawerHeader}>
                            <Typography style={{ fontSize: '15px', padding: '0px 80px 0 0' }} variant="h4">
                                Saurus PDV
                            </Typography>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>
                        </div>
                        <Divider />
                        <div style={{ backgroundColor: '#fafafa' }}>
                            <List >
                                <ListItem button className={classes.listFilho}>
                                    <ListItemIcon onClick={() => history.push('/cadastrar')}>
                                        Cadastrar-se
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            <Divider />
                            <ListItem button className={classes.list} >
                                <ListItemIcon onClick={() => history.push('/representante')}>
                                    Representante
                                </ListItemIcon>
                            </ListItem>
                        </div>
                        <Box flexGrow={1} bgcolor='#fafafa' />  {/* jogou o sair para baixo */}
                        <Divider classes={{ root: classes.divider }} />
                        <ListItem button className={classes.list} >
                            <Button style={{
                                fontSize: '14px',
                                color: 'rgba(0, 0, 0, 0.54)'
                            }} onClick={() => Logout(2)}>Sair</Button>
                        </ListItem>
                    </SwipeableDrawer>
                </>

                :
                <>
                    <div style={{ padding: '8px 8px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' style={{ backgroundColor: '#386D9F', zIndex: 1, color: '#fff' }} onClick={() => history.push('/login')}>Logar</Button>
                        <Button variant='outlined' style={{ backgroundColor: '#386D9F', zIndex: 1, color: '#fff' }} onClick={() => history.push('/representante')}>Representante</Button>
                    </div>
                </>
            }
            <div className="saurusPDVPage">
                <Helmet>
                    <title>Saurus PDV - Saurus AutoCom</title>
                    <meta content="#386D9F" name="theme-color" />
                </Helmet>
                <div className='d-none-pc'>
                    <img src={Back1} alt="" className="background1" />
                    <img src={Back2} alt="" className="background2" />
                    <img src={Back3} alt="" className="background3" />
                    <img src={BackFiguras1} alt="" className="background-figuras1" />
                    <img src={BackFiguras2} alt="" className="background-figuras2" />
                    <img src={BackFiguras3} alt="" className="background-figuras3" />
                    <img src={BackFiguras4} alt="" className="background-figuras4" />
                    <img src={BackFiguras5} alt="" className="background-figuras5" />
                    <img src={BackFiguras6} alt="" className="background-figuras6" />
                    <img src={BackFiguras7} alt="" className="background-figuras7" />
                </div>
                <div className='d-none-celular'>
                    <img src={BackDesk1} alt="" className="background-desk1" />
                    <img src={BackDesk2} alt="" className="background-desk2" />
                    <img src={BackDesk3} alt="" className="background-desk3" />
                    <img src={BackDesk4} alt="" className="background-desk4" />
                    <img src={BackDesk5} alt="" className="background-desk5" />
                    <img src={BackFigurasDesk1} alt="" className="background-figu-desk1" />
                    <img src={BackFigurasDesk2} alt="" className="background-figu-desk2" />
                    <img src={BackFigurasDesk3} alt="" className="background-figu-desk3" />
                    <img src={BackFigurasDesk3} alt="" className="background-figu-desk3-5" />
                    <img src={BackFigurasDesk3} alt="" className="background-figu-desk3-6" />
                    <img src={BackFigurasDesk4} alt="" className="background-figu-desk4" />
                    <img src={BackFigurasDesk4} alt="" className="background-figu-desk4-5" />
                    <img src={BackFigurasDesk5} alt="" className="background-figu-desk5" />
                    <img src={BackFigurasDesk5} alt="" className="background-figu-desk5-1" />
                    <img src={BackFigurasDesk5} alt="" className="background-figu-desk5-2" />
                    <img src={BackFigurasDesk5} alt="" className="background-figu-desk5-3" />
                    <img src={BackFigurasDesk6} alt="" className="background-figu-desk6" />
                </div>
                <div className="p-d-v1430-container">
                    <div className="p-d-v1430-p-d-v1430">
                        {user.id ?
                            <div className="p-d-v1430-group11911453" >
                            </div>
                            :
                            <div className="saurusPDVPage .p-d-v1430-group45218" >
                            </div>
                        }
                        <div className="sliders">
                            <div id="my-keen-slider" ref={refCallback} className="keen-slider">
                                <div className="keen-slider__slide slide-servicos-grande">
                                    <img src={IconsGrande().PDVGrande} alt="Imagem Saurus PDV" className="p-d-v1430-image25" />
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-v4">
                                        <img src={IconsPequeno().V4Pequeno} alt="Imagem SaurusV4" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-mobile">
                                        <img src={IconsPequeno().MobilePequeno} alt="Imagem Saurus Mobile" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/touchone">
                                        <img src={IconsPequeno().TouchOnePequeno} alt="Imagem TouchOne" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="p-d-v1430-conheao-saurus-p-d-v15174 container">
                            <div className="row ">
                                <div className="col-12 col-lg-6 align-items-center d-flex">
                                    <div>
                                        <span className="p-d-v1430-text02">
                                            <span className="p-d-v1430-text03">Conheça o</span>
                                            <div className="text-saurus-pdv">
                                                <span className="p-d-v1430-text04">
                                                    <span>SAURUS</span>
                                                </span>
                                                <span className="p-d-v1430-text08">PDV</span>
                                                <img src={Group15158} alt="Group15158" className="p-d-v1430-image06" />
                                            </div>
                                        </span>
                                        <div className="content-sistema-versatil mt-3">
                                            <span className="p-d-v1430-text38">
                                                <span className="p-d-v1430-text39">O sistema de caixa </span>
                                                <span className="p-d-v1430-text40">mais versátil </span>
                                                <span className="p-d-v1430-text41">
                                                    <span>do mercado.</span>
                                                    <br />
                                                    <span>Ajusta seus processos de </span>
                                                </span>
                                                <span className="p-d-v1430-text40">venda </span>
                                                <span className="p-d-v1430-text46">para atender </span>
                                                <span className="p-d-v1430-text40">diversos segmentos.</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 imagem-lado">
                                    <img src={PDVCaixa} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="container icons-content">
                            <div className="row">
                                <div className="col-6 col-lg-3">
                                    <div className="p-d-v1430-frentedecaixa11839">
                                        <img src={Group480879} alt="Group480879" className="p-d-v1430-image07 mb-1" />
                                        <span className="p-d-v1430-text09">
                                            <span className="p-d-v1430-text10">FRENTE DE CAIXA</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={Group4721050} alt="Group4721050" className="p-d-v1430-image21 mb-1" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">RETAGUARDA LOCAL</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="p-d-v1430-cupom-s-a-t-n-f-ce11850">
                                        <img src={Group4721012} alt="Group4721012" className="p-d-v1430-image22 mb-2" />
                                        <span className="p-d-v1430-text33">
                                            <span className="p-d-v1430-text34">
                                                <span>DIVERSOS</span>
                                                <br />
                                                <span>LAYOUTS DE TELA</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={Group4721051} alt="Group4721050" className="p-d-v1430-image21 mb-1" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">Cupom SAT NFC-e</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="my-keen-sliderr" ref={refCallback} className="keen-slider container mb-4">
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image1} rel="noreferrer" target="_blank">
                                    <img src={Image1} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image2} rel="noreferrer" target="_blank">
                                    <img src={Image2} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image3} rel="noreferrer" target="_blank">
                                    <img src={Image3} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image4} rel="noreferrer" target="_blank">
                                    <img src={Image4} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image5} rel="noreferrer" target="_blank">
                                    <img src={Image5} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container d-none-pc">
                            <div className="p-d-v1430-text48 ">
                                <span>
                                    <span>
                                        <span className="p-d-v1430-text49">SIMPLES, COMPLETO</span>
                                        <br />
                                        <span>e</span>
                                    </span>
                                    <span className="p-d-v1430-text54"> INTUITIVO</span>
                                </span>
                            </div>
                            <div>
                                <span className="p-d-v1430-text87">
                                    <span className="p-d-v1430-text88">Máquinas de cartão com </span>
                                    <span className="p-d-v1430-text89">pagamento integrado </span>
                                    <span className="p-d-v1430-text90">ao sistema, mais </span>
                                    <span className="p-d-v1430-text91">controle </span>
                                    <span className="p-d-v1430-text92">e </span>
                                    <span className="p-d-v1430-text93">segurança </span>
                                    <span className="p-d-v1430-text94">para o lojista.</span>
                                </span>
                            </div>
                            <div className="pdv-maquininha">
                                <img src={Group1221} alt="Group4721050" className="p-d-v1430-image21" />
                            </div>
                        </div>
                        <div className="container container-apps-integracoes">
                            <div className="row">
                                <div className="col-lg-5 col-12 apps-integracoes">
                                    <div className="margin-bottom-1rem">
                                        <span className="p-d-v1430-text55">
                                            <span className="p-d-v1430-text56">Apps e Integrações</span>
                                        </span>
                                        <hr className="hr-colorido" />
                                    </div>
                                    <div className="images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Mobile()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Comandas()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={S2Pay()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="margin-bottom-1rem">
                                        <span className="p-d-v1430-text55">
                                            <span className="p-d-v1430-text58">Integrações</span>
                                        </span>
                                        <hr className="hr-colorido" />
                                    </div>
                                    <div className="images-app-integracoes">
                                        <div className="row">
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={LojaIntegrada()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={Ifood()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={NuvemShop()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={SiteMercado()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>

                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={ClickMix()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={SupermercadosNow()} alt="Rectangle8658211807"
                                                    className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={OSuper()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                            <div className="col-4 col-lg-4 col-xl-3">
                                                <img src={PidoMe()} alt="Rectangle8658211807" className="app-integracao" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 d-none-celular">
                                    <div className='ms-4'>
                                        <div className="p-d-v1430-text48">
                                            <span>
                                                <span>
                                                    <span className="p-d-v1430-text49">SIMPLES, COMPLETO</span>
                                                    <br />
                                                    <span>e </span>
                                                    <span className="p-d-v1430-text54"> INTUITIVO</span>
                                                </span>
                                            </span>
                                        </div>
                                        <div>
                                            <span className="p-d-v1430-text87">
                                                <span className="p-d-v1430-text88">Máquinas de cartão com </span>
                                                <span className="p-d-v1430-text89">pagamento integrado </span>
                                                <span className="p-d-v1430-text90">ao sistema, mais </span>
                                                <span className="p-d-v1430-text91">controle </span>
                                                <span className="p-d-v1430-text92">e </span>
                                                <span className="p-d-v1430-text93">segurança </span>
                                                <span className="p-d-v1430-text94">para o lojista.</span>
                                            </span>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <div className="pdv-maquininha">
                                                    <img src={Group1221} alt="Group4721050" className="p-d-v1430-image21 image-width-100" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 d-none-celular">
                                                <div className="mt-5">
                                                    <div className="d-flex mb-5">
                                                        <img src={WhiteLabel} alt="" />
                                                        <div>
                                                            <span className="white-suporte">WHITE LABEL</span>
                                                            <br />
                                                            <span className="white-suporte-texto">
                                                                O <span>SAURUS PDV</span> também
                                                                permite customização para
                                                                que o sistema tenha a
                                                                identidade da sua marca!
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex">
                                                        <img src={SuporteTecnico} alt="" />
                                                        <div className="ms-3">
                                                            <span className="white-suporte">SUPORTE TÉCNICO</span>
                                                            <br />
                                                            <span className="white-suporte-texto">
                                                                Equipe <span>especializada </span>
                                                                no atendimento à
                                                                revendedores.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-5 pb-3">
                                                <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href="https://saurus.blob.core.windows.net/autocom/PDV.pdf" target="_blank">
                                                    <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                                    <span className="p-d-v1430-text60">PDF</span>
                                                </a>
                                                <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/pdv">
                                                    <span className="p-d-v1430-text62">Mais informações</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container mb-4 d-none-pc pb-3">
                            <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href="https://saurus.blob.core.windows.net/autocom/PDV.pdf" target="_blank">
                                <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                <span className="p-d-v1430-text60">PDF</span>
                            </a>
                            <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/saurus-pdv/" target="_blank" rel="noreferrer">
                                <span className="p-d-v1430-text62">Mais informações</span>
                            </a>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>

    )
}